export function fetch(idHotel) { return { type: 'HOTELS/FETCH', idHotel } }
export function fetchBySeason(idSeason) { return { type: 'HOTELS/SEASON/FETCH', idSeason } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/hotels.js